import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Home from "./Home";
import { API_URL } from "./constant";
import Login from "./Login";
import Header from "./Header";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Feedback from "./Feedback";

const App: React.FC = () => {
	const [isLoading, setIsLoading] = React.useState<boolean>(true);
	const [user, setUser] = useState<string>();

	const fetchUserProfile = async () => {
		try {
			const response = await fetch(API_URL + "/admin/profile", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
				credentials: "include",
			});
			if (response.ok) {
				const data = await response.json();
				setUser(data.user);
			} else {
				setUser('');
				console.error("Failed to fetch user profile");
			}
		} catch (error) {
			console.error("Error fetching user profile:", error);
		} finally {
			setIsLoading(false);
		}
	};

	React.useEffect(() => {
		fetchUserProfile();
	}, []);

	if (isLoading) {
		return (
			<div style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
			}}>
				<Spinner animation="grow" variant="success" />
			</div>);
	}
	if (!user) {
		return <Login setUser={fetchUserProfile} />
	}
	return (
		<Router>
			{user && <Header fetchUserProfile={fetchUserProfile} />}
			<Routes>
				{/* Redirect to Login if not authenticated */}
				<Route
					path="/"
					element={user ? <Navigate to="/home" /> : <Navigate to="/login" />}
				/>
				<Route
					path="/login"
					element={user ? <Navigate to="/home" /> : <Login setUser={setUser} />}
				/>
				<Route
					path="/home"
					element={user ? <Home /> : <Navigate to="/login" />}
				/>
				<Route
					path="/feedback"
					element={user ? <Feedback /> : <Navigate to="/login" />}
				/>
			</Routes>
		</Router>
	);
}

export default App;